export enum VIDEO_SIZE {
    BIG = "BIG",
    SAME = "SAME",
}
